import React from 'react';

import { ADDRESS, CONTACT_EMAIL, MAILTO } from '../../site';
import ArrowIcon from '../ui/ArrowIcon';
import Reveal from '../ui/Reveal';
import './cta.scss';

export default function CtaSection() {
  return (
    <section className="cta-section" id="contact">
      <div className="wrap">
        <Reveal className="cta-section__head">
          <p className="eyebrow eyebrow--center">Let&apos;s talk</p>
          <h2>Tell us what&apos;s slowing your business down.</h2>
          <p className="cta-section__lead">
            A 30-minute call is enough for us to tell you whether data, dev or AI is your
            fastest win.
          </p>

          <div className="cta-section__actions">
            <a href={MAILTO} className="btn btn--primary">
              Book a call
              <ArrowIcon />
            </a>
            <a href={`${MAILTO}?subject=Project%20inquiry`} className="btn btn--ghost">
              Email us instead
            </a>
          </div>
        </Reveal>

        <Reveal delay={120}>
          <dl className="cta-section__facts">
            <div>
              <dt>Email</dt>
              <dd>
                <a href={MAILTO}>{CONTACT_EMAIL}</a>
              </dd>
            </div>
            <div>
              <dt>Reply time</dt>
              <dd>Same business day</dd>
            </div>
            <div>
              <dt>Office</dt>
              <dd>{ADDRESS}</dd>
            </div>
          </dl>
        </Reveal>
      </div>
    </section>
  );
}
